import * as Home from './ui/home'
import * as System from './ui/system'
import * as Admin from './ui/admin'
import * as Transactions from './ui/transactions'
import { RouterModule, Routes } from '@angular/router'
import { AuthorizationGuardService, LogoutComponent } from 'ng-client-auth'
import { LoginComponent } from 'ng-client-auth'
import { DefaultComponent } from './ui/shared/default/default.component'

const app_routes: Routes = [
  {
    path: '',
    component: DefaultComponent,
    canActivate: [AuthorizationGuardService]
  },
  {
    path: 'home',
    children: [
      { path: '', redirectTo: 'index', pathMatch: 'full' },
      { path: 'index', component: Home.IndexComponent, canActivate: [AuthorizationGuardService] },
      { path: 'terms', component: Home.TermsComponent }
    ]
  },
  {
    path: 'system',
    canActivateChild: [AuthorizationGuardService],
    children: [
      { path: '', redirectTo: 'plans', pathMatch: 'full' },
      {
        path: 'markets',
        component: System.MarketComponent,
        children: [
          { path: '', component: System.MarketListComponent },
          { path: ':id', component: System.MarketEditComponent }
        ]
      },
      {
        path: 'plans',
        component: System.PlansComponent,
        children: [
          { path: '', component: System.PlansListComponent },
          { path: ':id', component: System.PlansEditComponent }
        ]
      },
      {
        path: 'providers',
        component: System.ProvidersComponent,
        children: [
          { path: '', component: System.ProvidersListComponent },
          { path: ':id', component: System.ProvidersEditComponent },
          { path: ':id/contacts', component: System.ProvidersEditContactsComponent }
        ]
      },
      {
        path: 'payers',
        component: System.PayersComponent,
        children: [
          { path: '', component: System.PayersListComponent },
          { path: ':id', component: System.PayersEditComponent }
        ]
      },
      {
        path: 'feeschedules',
        component: System.FeeScheduleComponent,
        children: [
          { path: '', component: System.FeeScheduleListComponent },
          { path: ':id', component: System.FeeScheduleEditComponent }
        ]
      },
      {
        path: 'entitygroups',
        component: System.EntityGroupComponent,
        children: [
          { path: '', component: System.EntityGroupListComponent },
          { path: ':id', component: System.EntityGroupEditComponent }
        ]
      },
      {
        path: 'bundledefinitions',
        component: System.BundleDefinitionComponent,
        children: [
          { path: '', component: System.BundleDefinitionListComponent },
          { path: ':id', component: System.BundleDefinitionEditComponent }
        ]
      },
      {
        path: 'uploaders',
        component: System.UploadersListComponent,
        data: { title: 'Uploader Tools', icon: 'fa-upload' }
      }
    ]
  },
  {
    path: 'transactions',
    canActivateChild: [AuthorizationGuardService],
    children: [
      { path: '', redirectTo: 'claims-list', pathMatch: 'full' },
      { path: 'claims-list', component: Transactions.ClaimsListComponent },
      { path: 'remit-list', component: Transactions.RemitListComponent },
      { path: 'payments', component: Transactions.PaymentsComponent }
    ]
  },
  {
    path: 'admin',
    canActivateChild: [AuthorizationGuardService],
    children: [
      { path: '', redirectTo: 'users', pathMatch: 'full' },
      {
        path: 'users',
        children: [
          { path: '', redirectTo: 'list', pathMatch: 'full' },
          { path: 'list', component: Admin.UsersListComponent }
        ]
      },
      {
        path: 'permissions',
        component: Admin.PermissionsViewComponent,
        data: { title: 'Permissions', icon: 'fa-vcard-o' }
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },

  { path: '**', redirectTo: '/', pathMatch: 'full' } // catch any unfound routes and redirect to home page
]

export const appRoutes = RouterModule.forRoot(app_routes, {})
